import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbvue/lib/css/mdb.min.css";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import setBanknumber from "../plugins/setBanknumber.js";
Vue.prototype.$banknumber = setBanknumber;
import axios from "axios";
axios.defaults.headers.common["cache-control"] = "no-cache";
axios.defaults.baseURL = "https://sms-fast.warmlight.online/api";
Vue.prototype.$axios = axios;

import VueSweetalert2 from "vue-sweetalert2"; //sweetalert
import VueClipboard from "vue-clipboard2";
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);
Vue.use(VueClipboard);
import * as mdbvue from "mdbvue";
for (const component in mdbvue) {
  Vue.component(component, mdbvue[component]);
}
import VueCountdownTimer from 'vuejs-countdown-timer';
Vue.use(VueCountdownTimer);

import moment from "vue-moment";
Vue.use(moment);

import momentjs from "moment";
Vue.use(momentjs);
const momentsjs = momentjs;
Vue.prototype.$momentjs = momentsjs;

import loader from "vue-ui-preloader";
Vue.use(loader);

const keypayload = "b7FI6NEBr9l29f1iGPWwcQtuR4bLUEL8W2E8lfUiPI0qwgvuiruf"; //ตัวแปรคงที่ไม่สามารถเปลียนแปลงค่าได้
Vue.prototype.$keypayload = keypayload;

import VueSession from "vue-session"; //session
Vue.use(VueSession);

import CKEditor from "@ckeditor/ckeditor5-vue";
Vue.use(CKEditor);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import VuejsPaginate from "vuejs-paginate";
Vue.component("paginate", VuejsPaginate);
Vue.use(VuejsPaginate);

import OtpInput from "@bachdgvn/vue-otp-input";
Vue.component("v-otp-input", OtpInput);

import VueCountdown from "@chenfengyuan/vue-countdown";
Vue.component(VueCountdown.name, VueCountdown);

//import VueFuse from 'vue-fuse'
//Vue.use(VueFuse)

import "vue2-datepicker/index.css";

Vue.config.productionTip = false;

import Notify from "mdbvue/lib/components/Notify";
Vue.use(Notify);

new Vue({
  router,
  store,
  render: (h) => h(App),
  components: {
    loader: loader,
  },
}).$mount("#app");

function add_index(data) {
  // data.forEach((val, index) => {
  //   data[index].id = index + 1;
  // });

  if (data) {
    let rData = data.map((item, index) => {
      let id = {
        id2: index + 1,
      };
      return {
        ...id,
        ...item,
      };
    });
    return rData;
  }
}
Vue.prototype.$add_index = add_index;
